export default __webpack_public_path__ + "static/media/scan.e90409ab.svg";